export const PreviousFHPEmploymentTypeConstants = {
  WORKED_AS_TROPPER: 'worked as tropper',
  APPLIED_AS_TROOPER: 'applied as trooper',
  APPLIED_AS_DUTY_OFFICER: 'applied as duty officer',
  APPLIED_AS_AUX_OFFICER: 'applied as aux officer',
  DENIED_EMPLOYMENT: 'denied employment'
}
